<template lang="pug">
	.version-settings(v-if="showed && creative && version" @click="hide()")
		.card(@click.stop)
			.card-header
				i.fa.fa-gear
				span Version Settings
				.version-id Version id: {{version.id}}
			.card-body.collapse.show
				.version-icon(v-if="creative.type === 'end-card'" :style="{backgroundImage: Version.getVersionScreenshot(creative, version)}")
				.form-horizontal
					.info-group(v-if="creative.type === 'playable'")
						.info-base(v-if="version.Tags.base") This is a base version which created by the developers. You can't rename it or make hidden.
						.info-custom(v-if="!version.Tags.base") This is a custom version created from "{{Version.getVersion(version.baseVersionId).codename}}" base version.
					.form-group.form-group-row.title-line.separator(:class="{short: creative.type === 'end-card'}")
						label.col-form-label Title of the version
						input.form-control.title(size="16" type="text" v-model="title" :disabled="version.Tags.base" @input="updateTitle")
					.form-group.separator.short-content(v-if="creative.type === 'end-card' && Object.keys(publisher.options.projectMarkers).length > 0")
						label.col-form-label For the creatives with specified markers only
						.marker-list
							button.creative-marker.btn(:class="{'btn-outline-dark': !_.includes(version.options.endCardMarkers, marker), 'btn-primary': _.includes(version.options.endCardMarkers, marker)}" type="button" @click="changeEndCardMarker(marker)" v-for="(markerData, marker) in publisher.options.projectMarkers") {{marker}}
					.form-group.form-group-row.hidden-version.separator(v-if="!version.Tags.base")
						label Hidden version
						label.float-right.switch.switch-label.switch-pill.switch-success.form-check-label
							input.switch-input.form-check-input(type="checkbox" v-model="hidden" @change="saveVersionHiddenStatus($event.target.checked)")
							span.switch-slider(data-checked="On" data-unchecked="Off")
					.progress.add-progress(:style="{visibility: version.isUploading ? 'visible' : 'hidden'}")
						.progress-bar.progress-bar-striped.progress-bar-animated(role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{width: (version.uploadProgress * 100) + '%'}")
					.form-actions
						button.btn.btn-danger.delete-version-button(type="button" v-if="!version.Tags.base" v-on:click="deleteVersion()" v-b-tooltip.hover.v-danger="{delay: { show: 500, hide: 100 }, title: 'Delete version'}")
							i.fa.fa-remove
							span Delete
						button.btn.btn-primary(type="button" v-if="creative.type === 'end-card'" v-on:click="takeScreenshot()" v-b-tooltip.hover.v-danger="{delay: { show: 500, hide: 100 }, title: 'Save version screenshot'}")
							i.fa.fa-camera
							span Save screenshot
						button.btn.btn-warning(v-if="creative.type === 'playable' && !version.Tags.base" type="button" v-on:click="openCreativesDropdown($event)" :disabled="targetCreatives.length === 0")
							i.fa.fa-arrow-right
							span Move to
						button.btn.btn-warning.upload-version-settings(type="button" v-if="creative.type === 'playable' && creative.Tags['cocos'] && User.currentUser.Tags['admin'] && version.Tags.base" v-on:click="uploadSettingsJSON()" v-b-tooltip.hover.v-danger="{delay: { show: 500, hide: 100 }, title: 'Upload JSON settings file'}")
							i.fa.fa-remove
							span Upload JSON
						button.btn.btn-primary.upload-version-settings(type="button" v-if="(creative.type === 'banner' && Access.check('banner-templates-edit')) || (creative.type === 'storyboard' && Access.check('storyboard-templates-edit'))" v-on:click="openTemplateSettings()" v-b-tooltip.hover.v-primary="{delay: { show: 500, hide: 100 }, title: (creative.type === 'storyboard' ? 'Storyboard' : 'Banner') + ' template settings'}")
							i.fa.fa-remove
							span {{ version.options.templateId ? 'Template settings' : ('Save as ' + (creative.type === 'storyboard' ? 'storyboard' : 'banner') + ' template') }}
						button.btn.btn-dark(type="button" v-on:click="hide()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen';
	import { Auth } from "../../services/Auth";

	import SetupSettings		from "./../../settings/settings";

	export default {
		name: "VersionSettings",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Preview Changed",
				"Preview Screenshot Upload Progress"
			]
		},
		data() {

			this.targetCreatives = [];
			this.version = null;

			return {
				title: '',
				hidden: false
			}

		},
		methods: {
			collectData(event, versionId) {

				if (event === 'show') this.version = Version.getVersion(versionId);
				else if (this.version) this.version = Version.getVersion(this.version.id);

				if (!this.version) return;

				this.creative = Creative.SelectedCreative;
				this.publisher = Publisher.getPublisher(this.creative['publisher_id'], Publisher.getSelectedServerId());

				this.title = this.version.codename || this.version.title;
				this.hidden = !!(this.version.Tags['hidden']);

				this.targetCreatives = _.filter(Creative.getOrderedCreativesList(Publisher.SelectedPublisher), creative => {

					return ((creative.options.gitRepositoryName === this.creative.options.gitRepositoryName && creative.options.gitBranchName !== this.creative.options.gitBranchName)
						|| _.intersection(creative.options.markers || [], this.creative.options.markers || []).length > 0) && creative.id !== this.creative.id;

				}).map(creative => {

					return {title: creative.title, name: creative.id};

				});

			},
			updateTitle() {

				Server.sendWithTimeout({
					RenameVersion: {
						versionId: this.version.id,
						title: this.title.trim()
					}
				}, null, 200);

			},
			changeEndCardMarker(creativeMarkerName) {

				if (_.includes(this.version.options.endCardMarkers, creativeMarkerName)) {

					Server.sendToServer({
						UnsetEndCardVersionMarker: {
							versionId: this.version.id,
							creativeMarkerName: creativeMarkerName
						}
					});

				} else {

					Server.sendToServer({
						SetEndCardVersionMarker: {
							versionId: this.version.id,
							creativeMarkerName: creativeMarkerName
						}
					});

				}

			},
			saveVersionHiddenStatus(isHide) {

				if (isHide) {

					Server.sendToSocket({
						HideVersion: this.version.id
					});

				} else {

					Server.sendToSocket({
						ShowVersion: this.version.id
					});

				}

			},
			deleteVersion() {

				Broadcast.call("Show VersionDelete", [this.version.id]);

				this.hide();

			},
			openTemplateSettings() {

				this.hide();

				Broadcast.call("Show TemplateSettings", [this.version.id, null, this.creative.type]);

			},
			takeScreenshot() {

				Broadcast.call("Send To iFrame", [{TakeScreenshot: true}]);

				Broadcast.once(`IFrame Data:EndCardScreenshot`, base64Data => {

					let formData = new FormData();

					formData.append("versionId", this.version.id);
					formData.append("screenshotData", base64Data);

					let url = `http://${SetupSettings["domain"]}/version/screenshot`;
					if (location.protocol === 'https:') url = `https://${SetupSettings["domain"]}/version/screenshot`;

					let xhr = new XMLHttpRequest();


					xhr.open("POST", url);
					Auth.authorizeRequest(xhr);

					xhr.upload.onprogress = e => {

						if (e.lengthComputable) {

							this.version.uploadProgress = e.loaded / e.total;
							Broadcast.call('Version Screenshot Upload Progress', [this.version]);

						}

					};

					xhr.upload.onloadstart = e => {

						this.version.isUploading = true;
						Broadcast.call('Version Screenshot Upload Progress', [this.version]);

					};

					xhr.upload.onloadend = e => {

						this.version.isUploading = false;
						Broadcast.call('Version Screenshot Upload Progress', [this.version]);

					};

					xhr.send(formData);

				});

			},
			uploadSettingsJSON() {

				let input = document.createElement('input');
				input.type = 'file';
				input.style.position = 'absolute';
				input.style.left = '0';
				input.style.top = '0';
				input.style.transform = 'scale(0.1)';
				input.style.visibility = 'hidden';
				document.body.appendChild(input);

				input.accept = "application/json";

				input.addEventListener('change', e => {

					this.uploadJSONFile(e.target.files[0]);

					document.body.removeChild(input);

				});

				input.addEventListener('blur', () => {

					document.body.removeChild(input);

				});

				input.click();

			},
			uploadJSONFile(file) {

				let formData = new FormData();

				formData.append("versionId", this.version.id);
				formData.append("file", file);

				let url = `${location.protocol}//${SetupSettings["domain"]}/version/json/`;

				let xhr = new XMLHttpRequest();


				xhr.open("POST", url);
				Auth.authorizeRequest(xhr);

				/* Код для тестирования прогресса загрузки

				this.version.isUploading = true;
				this.version.uploadProgress = 0.1;
				Broadcast.call('Version Screenshot Upload Progress', [this.version]);

				setTimeout(() => {
					this.version.uploadProgress = 1;
					Broadcast.call('Version Screenshot Upload Progress', [this.version]);
				}, 1000);

				setTimeout(() => {
					this.version.isUploading = false;
					Broadcast.call('Version Screenshot Upload Progress', [this.version]);
				}, 1300);*/

				xhr.upload.onprogress = e => {

					if (e.lengthComputable) {

						this.version.uploadProgress = e.loaded / e.total;

						Broadcast.call('Version Screenshot Upload Progress', [this.version]);

					}

				};

				xhr.upload.onloadstart = () => {

					this.version.isUploading = true;

					Broadcast.call('Version Screenshot Upload Progress', [this.version]);

				};

				xhr.upload.onloadend = () => {

					this.version.isUploading = false;

					Broadcast.call('Version Screenshot Upload Progress', [this.version]);

					this.hide();

				};

				xhr.send(formData);

			},
			openCreativesDropdown(event) {

				Broadcast.call("Show ItemsDropdown", [event.target, this.targetCreatives, {title: 'Move version to...'}, clickedCreativeId => {

					Server.sendToSocket({
						MoveVersion: {
							versionId: this.version.id,
							creativeId: clickedCreativeId
						}
					});

					this.hide();

				}]);

			}
		}
	}
</script>

<style lang="sass">

	.version-settings
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		justify-content: center
		align-items: center

		.version-id
			position: absolute
			top: 19px
			right: 19px
			opacity: 0.1

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.info-group
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.form-group
			display: flex
			flex-direction: column

			.switch-slider
				background-color: #343b41
				border: 1px solid #23282c

			&.short
				width: 320px

			&.short-content
				padding-right: 160px

			&.hidden-version
				padding-bottom: 10px
				padding-top: 5px

			&.title-line
				padding-bottom: 10px

				input.title
					width: 250px
					// margin-top: 5px

		.form-group-row
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			padding-bottom: 0
			justify-content: space-between

		.version-icon
			position: absolute
			right: 20px
			top: 59px
			height: calc(1920px / 10)
			width: calc(1080px / 10)
			background-size: contain
			background-repeat: no-repeat
			background-position: center

		.card
			width: 500px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.form-actions
				margin-top: 20px

			label.col-form-label
				white-space: nowrap
				margin-right: 20px

			.progress.add-progress
				height: 5px
				margin-top: 10px
				margin-bottom: 10px

			.btn-primary

				i
					margin-right: 10px

			.btn-danger, .btn-warning
				margin-right: 10px

				i
					margin-right: 10px

			.btn-warning, .btn-warning:active:focus
				color: #FFFFFF

			.btn-dark
				float: right
				color: #fff

			.title-row
				display: flex
				flex-direction: row
				justify-content: space-between
				align-items: center

			button.creative-marker
				margin-right: 10px

</style>

